/* unplugin-vue-components disabled */import { render } from "./PopTemple.vue?vue&type=template&id=8f297b74&scoped=true&lang=pug"
import script from "./PopTemple.vue?vue&type=script&lang=js"
export * from "./PopTemple.vue?vue&type=script&lang=js"

import "./PopTemple.vue?vue&type=style&index=0&id=8f297b74&scoped=true&lang=stylus"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f297b74"]])

export default __exports__